import styled from "@emotion/styled";
import { FC, ReactNode } from "react";

import { Checkbox, DesignToken, Heading, SpacingToken, Tooltip } from "@livechat/design-system-react-components";

import { LiveChatDataImportType } from "routes/settings/integrations/constants";
import { withVar } from "themes/helpers";

interface IProps {
  type: LiveChatDataImportType;
  title: ReactNode;
  onClick: (option: LiveChatDataImportType) => void;
  selected: boolean;
  ticketsImportSelected?: boolean;
  addons?: ReactNode;
}

export const ImportOptionCard: FC<IProps> = ({
  type,
  title,
  onClick,
  selected,
  ticketsImportSelected = false,
  addons,
}) => {
  const handleClick = (): void => onClick(type);

  const ImportCheckbox = (
    <StyledCheckbox id={type} onChange={handleClick} checked={selected} disabled={ticketsImportSelected} />
  );

  return (
    <Wrapper htmlFor={type} selected={selected} disabled={ticketsImportSelected}>
      {ticketsImportSelected ? (
        <Tooltip triggerRenderer={ImportCheckbox} placement="top" kind="invert">
          It’s required when you import tickets.
        </Tooltip>
      ) : (
        ImportCheckbox
      )}
      <Title size="xs" customColor={withVar(DesignToken.ContentBasicPrimary)}>
        {title}
      </Title>
      {addons}
    </Wrapper>
  );
};

const Wrapper = styled.label<{ selected: boolean; disabled: boolean }>`
  display: flex;
  gap: ${withVar(SpacingToken.Spacing2)};
  align-items: center;

  box-sizing: border-box;
  min-height: 56px;
  border-radius: ${withVar(SpacingToken.Spacing2)};
  border: 1px solid
    ${(p): string => withVar(p.selected ? DesignToken.ActionPrimaryDefault : DesignToken.BorderBasicSecondary)};
  padding: ${withVar(SpacingToken.Spacing3)} 16px;
  transition: border-color 0.2s ease-in-out;
  cursor: ${(p): string => (p.disabled ? "not-allowed" : "pointer")};
`;

const Title = styled(Heading)`
  padding-left: ${withVar(SpacingToken.Spacing1)};
`;

const StyledCheckbox = styled(Checkbox)<{ checked: boolean }>`
  padding-top: ${withVar(SpacingToken.Spacing05)};

  input {
    &:focus {
      box-shadow: none;
    }
  }

  input:disabled {
    cursor: not-allowed;
    border-color: ${withVar(DesignToken.ActionPrimaryDefault)};
    background-color: ${withVar(DesignToken.ActionPrimaryDefault)};
  }
`;
